export enum ComingSoonPageTypeEnum {
  RETAIL = 'retail',
  E_COMMERCE = 'eCommerce',
  ALL = 'all'
}
